export default __webpack_public_path__ + "static/media/dior.e86ed8e7.png";